import * as React from "react";
import { Input } from "@/components/ui/input";
import { Clock } from "lucide-react";

interface TimePickerProps {
  value: string | undefined;
  onChange: (time: string) => void;
  className?: string;
}

export function TimePicker({ value, onChange, className }: TimePickerProps) {
  return (
    <div className={`relative flex items-center ${className}`}>
      <Clock className="absolute left-3 h-4 w-4 text-slate-400 pointer-events-none" />
      <Input
        type="time"
        value={value || "08:00"}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9 focus:ring-2 focus:ring-blue-500 rounded-lg h-11 border-slate-200"
      />
    </div>
  );
}
